export const SOCKET_DATA_STORE = "SOCKET_DATA_STORE"

export const SCHEDULE_CREATE = "SCHEDULE_CREATE"
export const SCHEDULE_UPDATE = "SCHEDULE_UPDATE"
export const SCHEDULE_DELETE = "SCHEDULE_DELETE"
export const SCHEDULE_START = "SCHEDULE_START"
export const SCHEDULE_STOP = "SCHEDULE_STOP"
export const SCHEDULE_CONVERT_STOP = "SCHEDULE_CONVERT_STOP"
export const SCHEDULE_CONVERT_START = "SCHEDULE_CONVERT_START"
